export const supportedLanguageCodes = [
  "en", // English
  "en-US", // English (United States)
  "ja", // Japanese
  "ja-JP", // Japanese (Japan)
  "th", // Thai
  "th-TH", // Thai (Thailand)
] as const

export type SupportedLanguageCode = (typeof supportedLanguageCodes)[number]

const unselectableLanguageCodes = new Set(["en", "ja-JP", "th-TH"])

export const selectableLanguageCodes = supportedLanguageCodes.filter(
  (languageCode) => !unselectableLanguageCodes.has(languageCode)
)

export type SelectableLanguageCode = (typeof selectableLanguageCodes)[number]

export const translationNamespaces = [
  "common",
  "data",
  "database",
  "reports",
  "sites",
  "user-settings",
] as const

export type TranslationNamespace = (typeof translationNamespaces)[number]
